import logging from 'utils/logging';
import { 
  GAMESTATE_PREGAME,
  GAMESTATE_LOBBY
} from '../../gamestate/constants';
import { HOST_STATUS, MOMENT_TYPES, NARRATION_KEYS } from '../hostStateSlice';

const log = logging.getLogger('moments.LobbyWelcome');
log.setLevel('info');

/**
 * Moment that triggers when transitioning from pregame to lobby
 */
export const LobbyWelcomeMoment = {
  id: 'pregame-to-lobby',
  shouldTrigger: ({ prevState, currentState, currentPlayers }) => {
    // Check if we've just transitioned from pregame to lobby
    log.debug(`Checking if moment PREGAME_TO_LOBBY should trigger`);
    log.debug(`Current state: ${currentState?.currentState}`);
    log.debug(`Previous state: ${prevState?.currentState}`);

    const shouldTrigger = (
      currentState?.currentState === GAMESTATE_LOBBY &&
      (prevState && prevState.currentState === GAMESTATE_PREGAME)
    );

    if (shouldTrigger) {
      log.info(`LobbyWelcomeMoment shouldTrigger: ${shouldTrigger}`);
      return {
        shouldTriggerAction: false,
        shouldGenerateNarration: true,
        narrationParams: {
          narrationKey: NARRATION_KEYS.LOBBY_WELCOME,
          momentType: MOMENT_TYPES.LOBBY_WELCOME,
          context: {
            // Include any other context needed for the welcome narration
            playerCount: currentPlayers?.length || 0,
            hasPlayers: currentPlayers?.length > 0
          }
        }
      };
    }

    return false;
  }
};

/**
 * Playback logic for the lobby welcome narration
 */
export const LobbyWelcomePlaybackMoment = {
  id: 'PLAY_LOBBY_WELCOME',
  narrationKey: 'LOBBY_WELCOME',
  momentType: MOMENT_TYPES.LOBBY_WELCOME,
  shouldPlay: (gameState, hostState, narration, playedNarrations) => {
    log.debug('LobbyWelcomePlaybackMoment shouldPlay: ', { gameState, hostState, narration, playedNarrations });
    // Check if we're in the right state
    const inLobby = gameState?.currentState === GAMESTATE_LOBBY;
    
    // Check if narration exists and is ready to play
    const narrationReady = narration && narration.textStatus === "READY" && (narration.audioStatus === "READY" || narration.audioStatus === "ERROR");
    
    // Check if host is available to speak (not already speaking)
    const hostAvailable = hostState?.status !== HOST_STATUS.SPEAKING;
    
    // Check if this narration has been played before
    const notPlayedYet = !playedNarrations.has(narration.key);
    
    log.debug(`PLAY_LOBBY_WELCOME check: inLobby=${inLobby}, narrationReady=${narrationReady}, hostAvailable=${hostAvailable}, notPlayedYet=${notPlayedYet}`);
    
    const shouldPlay = inLobby && narrationReady && hostAvailable && notPlayedYet;
    
    if (shouldPlay) {
      log.info("PLAY_LOBBY_WELCOME should play");
    }

    return shouldPlay;
  },
  onComplete: null // No automatic state transition after welcome
};

const api = {
  trigger: LobbyWelcomeMoment,
  playback: LobbyWelcomePlaybackMoment
};

export default api;
